import db from '../../firebase/init';
import { fetchJoinedCommunities, fetchJoinedCommunity } from '../../api/community.js';
import { getGroupsAndCommunityMembers, getInactiveMembers } from '../../api/communityMember.js';

import { CONST } from '../../constant';

export const community = {
  strict: true, // true => strict update state from component

  state: {
    communities: window.$commin.communities,
    communityMap: window.$commin.toMap(window.$commin.communities),
    fcid: window.$commin.fcid(window.$commin.communities),
    selectedCommunity: window.$commin.communities[0],
    addCommunityDialog: false,
    pageTitle: null,
    groupUpdatedTime: {},
    memberLoadings: {},
    memberLoadTimes: {},
    loading: false,
    communityUpdatedTime: 0,
    friendUpdatedTime: 0,
    refreshRequest: 0,
    gmLoading: { status: {}, qs: {} },
    iaGmLoading: { status: {}, qs: {} },
  },

  getters: {
    getCommunity: state => id => {
      return state.communities.find(community => community.id === id);
    },
  },

  mutations: {
    COM_SORT: (state, sort) => {
      for (var c of state.communities) {
        if (!c.id) continue;
        var s = sort[c.cmid];
        if (!s) continue;
        c.sort = s;
      }
      state.communities.sort((a, b) => {
        if (!a.id) return -1;
        if (!b.id) return 1;
        if (a.sort == b.sort) return a.updated_at > b.updated_at ? -1 : 1;
        return a.sort < b.sort ? -1 : 1;
      });
    },
    COM_UPDATE_PROFILE: (state, d) => {
      var cid = d.cid;
      var path = d.path;
      var c = state.communityMap[cid];
      if (c) c.cm_cover_path = path;
    },
    REMOVE_COMMUNITY: (state, payload) => {
      console.log('remove community id [' + payload + ']');
      state.communities.some(function(v, i) {
        if (v.id == payload) state.communities.splice(i, 1);
      });
      state.communityMap = window.$commin.toMap(state.communities);
    },
    CHANGE_COMMUNITY_COVER: (state, payload) => {
      console.log('community changed to id [' + payload.id + ']');
      var c = state.communityMap[payload.id];
      if (c) {
        c.cover_path = payload.path;
      }
    },
    CHANGE_COMMUNITY_NAME: (state, payload) => {
      console.log('community changed to id [' + payload.id + ']');
      var c = state.communityMap[payload.id];
      if (c) {
        c.name = payload.name;
      }
    },
    SET_FRIEND_NAME: (state, payload) => {
      for (var c of state.communities) {
        if (c.f) {
          c.has_cm_name = 1;
          break;
        }
      }
    },
    SET_SHOULD_INVITE: (state, payload) => {
      var c = state.communityMap[payload.id];
      if (c) {
        c.should_invite = payload.value;
      }
    },
    OPEN_ADD_COMMUNITY_DIALOG: (state, payload) => {
      state.addCommunityDialog = payload;
    },
    COM_SAVE_MEMBER_LOADING: (state, payload) => {
      state.memberLoadings[payload.cid] = payload.status;
    },
    COM_SAVE_MEMBER_LOAD_TIME: (state, cid) => {
      state.memberLoadTimes[cid] = time();
    },

    COM_SELECT_COMMUNITY: (state, payload) => {
      console.log('community changed to id [' + payload.id + ']');
      state.selectedCommunity = payload;
    },
    COM_LOADING: (state, loading) => {
      state.loading = loading;
    },
    COM_INIT_GROUP_UPDATED_AT: (state, payload) => {
      if (!payload) return;
      if (Array.isArray(payload)) {
        for (var k of payload) {
          state.groupUpdatedTime[k] = payload[k];
        }
      } else {
        for (var k of Object.keys(payload)) {
          state.groupUpdatedTime[k] = payload[k];
        }
      }
    },
    COM_SET_FRIEND_UPDATED_AT: (state, at) => {
      state.friendUpdatedTime = at;
    },
    COM_SET_GROUP_UPDATED_AT: (state, payload) => {
      state.groupUpdatedTime[payload.cid] = payload.at;
    },
    COM_SET_COMMUNITY_UPDATED_AT: (state, at) => {
      state.communityUpdatedTime = at;
    },
    COM_REFRESH: (state, payload) => {
      console.log('communities fetched!');
      state.communities = payload.cs;
      state.communityMap = window.$commin.toMap(payload.cs);
      state.fcid = window.$commin.fcid(payload.cs);
    },
    COM_REPLACE: (state, c) => {
      console.log('replace c');
      var cs = [];
      for (var i = 0, n = state.communities.length; i < n; i++) {
        if (state.communities[i].id == c.id) {
          cs.push(c);
          state.communityMap[c.id] = c;
        } else cs.push(state.communities[i]);
      }
      state.communities = cs;
    },
    COM_UPDATE_BASIC_INFO(state, payload) {
      var commit = payload.commit;
      var c = payload.c;
      var at = payload.at;
      console.log(`update basic info ${c.id}`);
      if (at) c.basic_info_changed_at = at;

      fetchJoinedCommunity(c.id)
        .then(function(response) {
          var c = response.data;
          commit('COM_REPLACE', c);
        })
        .catch(function(e) {
          console.error(`failed to get latest community ${c.id}`, e);
        });
    },
    COM_UPDATE_MEMBER(state, payload) {
      var commit = payload.commit;
      var cid = payload.cid;

      if (cid == state.fcid) return console.error(`no update community ${cid}`);

      var mat = payload.mat;
      var gat = payload.gat;
      var cb = payload.cb;
      var c = state.communityMap[cid];
      console.log(`update member ${cid}`);
      if (mat) c.member_changed_at = mat;
      if (gat) c.group_changed_at = gat;

      if (state.gmLoading.status[cid]) {
        var qs = state.gmLoading.qs[cid];
        if (!qs) {
          qs = [];
          state.gmLoading.qs[cid] = qs;
        }
        qs.push(payload);
        return;
      }
      state.gmLoading.status[cid] = true;

      var key = `groups-members-${cid}`;
      getGroupsAndCommunityMembers(c.id)
        .then(function(response) {
          var mat = response.member_changed_at;
          var gat = response.group_changed_at;
          commit('COM_UPDATE_MEMBER_CHANGED_AT', { c: c, at: mat });
          commit('COM_UPDATE_GROUP_CHANGED_AT', { c: c, at: gat });
          var gs = {},
            cms = {};
          for (var g of response.groups) gs[g.id] = g;
          for (var cm of response.communityMembers) cms[cm.id] = cm;
          var r = { mat: mat, gat: gat, gs: gs, cms: cms };
          window.$commin.clientdb.putObject(key, r);

          if (cb) cb(r);
          var qs = state.gmLoading.qs[cid];
          if (qs && qs.length > 0) {
            for (var q of qs) {
              if (q.cb) q.cb(r);
            }
            state.gmLoading.qs[cid] = [];
          }
          state.gmLoading.status[cid] = false;
        })
        .catch(function(e) {
          console.error(`failed to get latest member for community ${cid}`, e);
        });
    },
    COM_UPDATE_FRIEND(state, payload) {
      var cid = state.fcid;

      var at = payload.at;
      state.friendUpdatedTime = at;

      var cb = payload.cb;
      var inactiveCb = payload.inactiveCb;

      var key = `groups-members-${cid}`;
      var inactiveKey = `inacitve-members-${cid}`;
      getGroupsAndCommunityMembers(cid, true)
        .then(function(response) {
          var mat = response.member_changed_at;
          var gat = response.group_changed_at;
          var gs = {},
            cms = {},
            inactiveCms = {};
          for (var g of response.groups) gs[g.id] = g;
          for (var cm of response.communityMembers) {
            if (cm.friend_status == CONST.FRIEND_STATUS.ACTIVE) {
              cms[cm.id] = cm;
            } else {
              inactiveCms[cm.id] = cm;
            }
          }
          var r = { mat: at, gat: at, gs: gs, cms: cms };
          var ir = { mat: at, cms: inactiveCms };
          window.$commin.clientdb.putObject(key, r);
          window.$commin.clientdb.putObject(inactiveKey, ir);
          if (cb) cb(r);
          if (inactiveCb) inactiveCb(ir);
        })
        .catch(function(e) {
          console.error(`failed to get latest member for friend ${cid}`, e);
        });
    },
    COM_UPDATE_INACTIVE_MEMBER(state, payload) {
      var commit = payload.commit;
      var cid = payload.cid;

      if (cid == state.fcid) return console.error(`no update community ${cid}`);

      var mat = payload.mat;
      var cb = payload.cb;
      var c = state.communityMap[cid];
      console.log(`update member ${cid}`);
      if (mat) c.member_changed_at = mat;

      if (state.iaGmLoading.status[cid]) {
        var qs = state.iaGmLoading.qs[cid];
        if (!qs) {
          qs = [];
          state.iaGmLoading.qs[cid] = qs;
        }
        qs.push(payload);
        return;
      }
      state.iaGmLoading.status[cid] = true;

      var key = `inacitve-members-${cid}`;
      getInactiveMembers(c.id)
        .then(function(response) {
          var mat = response.member_changed_at;
          var cms = {};
          for (var cm of response.cms) cms[cm.id] = cm;
          var r = { mat: mat, cms: cms };
          window.$commin.clientdb.putObject(key, r);

          if (cb) cb(r);
          var qs = state.iaGmLoading.qs[cid];
          if (qs && qs.length > 0) {
            for (var q of qs) {
              if (q.cb) q.cb(r);
            }
            state.iaGmLoading.qs[cid] = [];
          }
          state.iaGmLoading.status[cid] = false;
        })
        .catch(function(e) {
          console.error(`failed to get latest inactive member for community ${cid}`, e);
        });
    },
    COM_UPDATE_MEMBER_CHANGED_AT(state, payload) {
      payload.c.member_changed_at = payload.at;
    },
    COM_UPDATE_GROUP_CHANGED_AT(state, payload) {
      payload.c.group_changed_at = payload.at;
    },
  },

  actions: {
    refreshCommunity({ state, commit, rootState }, at) {
      if (state.loading) return;
      commit('COM_LOADING', true);

      // get from server
      var self = this;
      fetchJoinedCommunities()
        .then(function(response) {
          var updatedTime = response.data.updated_at;
          var cs = response.data.list;
          commit('COM_REFRESH', { loadFromServer: true, cs: cs, updatedTime: updatedTime });
          commit('COM_LOADING', false);
        })
        .catch(function(e) {
          console.error(e);
          commit('OPEN_SNACKBAR', { msg: $T('common.err.get.new'), danger: true });
          commit('COM_LOADING', false);
        });
    },
  },
};
